import { UserProfile } from 'types';
import { ContactsAssignmentsTable } from './ContactsAssignmentsTable';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

interface Props {
  contacts: UserProfile[];
  lenderProfileId: string;
}

export const ContactsAssignmentsCard = ({ contacts, lenderProfileId }: Props) => {
  return (
    <CardContainer title="Lender Role Assignment">
      <ContactsAssignmentsTable contacts={contacts} lenderProfileId={lenderProfileId} />
    </CardContainer>
  );
};
